import {useCallback} from 'react';
import {EventAction, EventCategory, EventNames} from 'modules/google-analytics/constants';

import {sendGtagEvent} from 'hooks/analytics/gtag/helpers';

/**
 * Отправляет событие клика по ссылке 'Винный клуб Privé'
 * Формат события:
 * dataLayer.push({
 *   'event': 'OWOX',
 *   'eventCategory': 'Interactions',
 *   'eventAction': 'Click',
 *   'eventLabel': 'priveLink'
 * });
 */
export const usePriveLinkClickGtag = () => {
    return useCallback(() => {
        sendGtagEvent({
            event: EventNames.OWOX,
            eventCategory: EventCategory.Interactions,
            eventAction: EventAction.Click,
            eventLabel: 'priveLink',
        });
    }, []);
};
